import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NdmsSafeSubscriber } from '../../../../../../shared/core/interfaces/ndms-safe-subscriber';
import { SidebarNavMenuService } from '../../../core-rms/sidebar-nav-menu.service';
import { SidebarRendererComponent } from './sidebar-renderer/sidebar-renderer.component';

@Component({
    selector: 'app-base',
    template: ``
})
export class BaseSideBarNavComponent extends NdmsSafeSubscriber implements OnInit, OnDestroy {
    subscription: Subscription;
    private model: any[];

    constructor(public nav: SidebarRendererComponent,
        public linksvc: SidebarNavMenuService) {
        super();
      this.subscription = this.linksvc.links$.subscribe(m => this.model = m);
    }
    
    ngOnInit(): void {

    }

    onMenuClick() {
    }

    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }
}
